import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import store from "./_redux/store";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./_theme";
import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Helmet } from "react-helmet";
import metaData from "./_data/metaData";
import linksData from "./_data/linksData";
import siteData from "./_data";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./pages/ErrorPage";

const root = ReactDOM.createRoot(document.getElementById("root"));

const Home = () => (
  <>
    <Helmet>
      {/* Dynamically add meta tags */}
      {metaData.map((meta, index) => (
        <meta key={index} {...meta} />
      ))}

      {/* Dynamically add link tags */}
      {linksData.map((link, index) => (
        <link key={index} {...link} />
      ))}

      <title>{siteData.brand.name}</title>
    </Helmet>

    <App />
  </>
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
    
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <CssBaseline />

          <ErrorBoundary FallbackComponent={ErrorPage}>
            <Home />
          </ErrorBoundary>
        </LocalizationProvider>
      </ThemeProvider>

    </Provider>
  </React.StrictMode>
);
